import { Phone } from "lucide-react";

export default function CallFAB() {
  return (
    <a
      href="tel:+919819933676"
      className="fixed bottom-[5.25rem] right-5 md:bottom-[6.5rem] md:right-8 z-50 flex items-center gap-2 rounded-full bg-gradient-to-br from-dd-gold to-dd-gold-dark text-dd-ink-dark pl-4 pr-5 py-3 shadow-xl dd-call-pulse hover:from-dd-gold-light hover:to-dd-gold transition-colors"
      data-testid="call-fab"
      aria-label="Call Divya Dhara"
    >
      <Phone className="w-5 h-5" strokeWidth={2.25} />
      <span className="hidden sm:inline font-bold text-sm tracking-wide">Call Now</span>
    </a>
  );
}
